<template>
  <div class="search-area-detail-form">
    <div class="form-main-row">
      <base-select-box
        class="select-box"
        :value="searchCondition.selectId"
        :selectData="selectBoxData"
        :styles="selectBoxWidth"
        :disabled="searchCondition.isSelectIdBoxDisabled"
        @input="select"
      />
      <validation-provider
        class="validate"
        :rules="{ notSurrogatePair: true }"
        v-slot="{ errors }"
        v-if="inputType === 'textBox'"
        ><base-text-box
          class="input-form"
          :value="searchCondition.text"
          :styles="{ width: '265px' }"
          @input="inputText"
          @keyup="$emit('keyup')"
        /><span class="error" data-test="error">{{ errors[0] }} </span>
      </validation-provider>
      <div class="radio-button-form" v-if="inputType === 'radioButton'">
        <base-radio-button
          v-for="datum in radioButtonData"
          :key="datum.id + 'radio'"
          :option="datum"
          :value="searchCondition.text"
          :styles="radioButtonWidth"
          @input="inputText"
        />
      </div>
      <v-date-picker
        :key="updatedDateCount"
        class="input-form date-picker"
        data-test="v-date-picker"
        v-if="inputType === 'datePicker'"
        is-range
        :value="date"
        @input="inputDate"
        ref="vDatePickerDate"
      >
        <template v-slot="{ inputValue, inputEvents, togglePopover }">
          <input
            class="v-date-picker"
            :value="inputValue.start + ' - ' + inputValue.end"
            v-on="inputEvents"
            @click="togglePopover"
            readonly
          />
        </template>
      </v-date-picker>
      <base-select-box
        class="input-form select-box"
        v-if="inputType === 'selectBox'"
        :value="searchCondition.text"
        :selectData="selectData"
        @input="inputText"
      />
      <div
        class="one-date-picker-select-box"
        v-if="inputType === 'oneDatePickerSelectBox'"
      >
        <base-select-box
          class="input-form select-box"
          :value="searchCondition.text"
          :selectData="selectData"
          @input="inputText"
        />
        <v-date-picker
          class="input-form date-picker"
          data-test="v-date-picker"
          :value="date"
          @input="inputOneDate2"
          ref="vDatePickerOneDate2"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              class="v-date-picker"
              :value="inputValue"
              v-on="inputEvents"
              readonly
            />
          </template>
        </v-date-picker>
      </div>
      <div class="text-boxes" v-if="inputType === 'textBoxes'">
        <validation-provider
          class="validate"
          :rules="{ notSurrogatePair: true, regexNumber: true }"
          v-slot="{ errors }"
          ><base-text-box
            :value="searchCondition.text"
            :styles="{ width: '90px' }"
            :fullWidthNumbersToHalfWidthNumbers="true"
            @input="inputText"
            @keyup="$emit('keyup')"
          /><span
            v-if="inputType === 'textBoxes'"
            class="error"
            data-test="error-text1"
            >{{ errors[0] }}</span
          >
        </validation-provider>
        <span class="young">{{ textBoxesText }}以上</span>
        <div class="kara">～</div>
        <validation-provider
          class="validate"
          :rules="{ notSurrogatePair: true, regexNumber: true }"
          v-slot="{ errors }"
          ><base-text-box
            :value="searchCondition.text2"
            :styles="{ width: '90px' }"
            :fullWidthNumbersToHalfWidthNumbers="true"
            @input="inputText2"
            @keyup="$emit('keyup')"
          /><span
            v-if="inputType === 'textBoxes'"
            class="error"
            data-test="error-text2"
            >{{ errors[0] }}</span
          >
        </validation-provider>
        <div class="old">{{ textBoxesText }}以下</div>
      </div>
      <div
        class="radio-button-period-form"
        v-if="inputType === 'radioButtonPeriod'"
      >
        <div class="radio-buttons">
          <base-radio-button
            v-for="datum in radioButtonData"
            :key="datum.id + 'radio'"
            :option="datum"
            :value="searchCondition.text"
            :styles="radioButtonWidth"
            @input="inputText"
          />
        </div>
        <v-date-picker
          :key="updatedDateCount"
          class="input-form"
          data-test="radio-v-date-picker"
          v-if="radioButtonPeriodShowFlg"
          :input-props="{ class: 'v-date-picker', readonly: true }"
          is-range
          :min-date="new Date()"
          :value="date"
          @input="inputDate2"
          ref="vDatePickerDate2"
        >
          <template v-slot="{ inputValue, inputEvents, togglePopover }">
            <input
              class="v-date-picker"
              :value="inputValue.start + ' - ' + inputValue.end"
              v-on="inputEvents"
              @click="togglePopover"
              readonly
            />
          </template>
        </v-date-picker>
      </div>
      <div
        class="period-radio-button-form"
        v-if="inputType === 'periodRadioButton'"
      >
        <div class="period">
          <validation-provider
            class="validate"
            :rules="`startDateRule:${searchCondition.text2}`"
            v-slot="{ errors }"
            ><base-date-picker
              data-test="period-start"
              :clearFlg="true"
              :value="searchCondition.text"
              @input="inputText"
              @clear="clear('text')"
            />
            <div class="error" data-test="error-date1">{{ errors[0] }}</div>
          </validation-provider>
          <div class="wavy-line">～</div>
          <base-date-picker
            data-test="period-end"
            :clearFlg="true"
            :value="searchCondition.text2"
            @input="inputText2"
            @clear="clear('text2')"
          />
        </div>
        <div class="radio-buttons">
          <div class="label">{{ searchCondition.label }}</div>
          <base-radio-button
            v-for="datum in radioButtonData"
            :key="datum.id + 'radio'"
            :option="datum"
            :value="searchCondition.text3"
            :styles="{ marginRight: '10px' }"
            @input="inputText3"
          />
        </div>
      </div>
      <div v-if="inputType === 'tagsSelect'" class="tag-select-form">
        <div class="tag-list-wrapper">
          <tag-list
            :selectedTagIds="searchCondition.text"
            :tags="ownerTags"
            @select-tag="selectTag"
          />
        </div>
        <div class="checkbox-wrapper">
          <base-check-box
            class="checkbox"
            :labelStyle="{ marginLeft: '5px' }"
            :isChecked="searchCondition.text2"
            :labelText="'選択したタグを設定している飼主を除外'"
            @input="toggleTagOption"
          />
        </div>
      </div>
      <base-button-trash
        class="trash-button"
        v-if="index !== 0"
        @click="trash"
      />
    </div>

    <div
      class="deleted-error"
      data-test="deleted-error"
      v-if="isDeletedCondition"
    >
      選択していた条件が削除されています。検索を続けるには、条件を選び直してください。
    </div>
  </div>
</template>
<script>
import BaseCheckBox from '@/components/parts/atoms/BaseCheckBox'
import BaseSelectBox from '@/components/parts/atoms/BaseSelectBox'
import BaseTextBox from '@/components/parts/atoms/BaseTextBox'
import BaseButtonTrash from '@/components/parts/atoms/BaseButtonTrash'
import BaseRadioButton from '@/components/parts/atoms/BaseRadioButton'
import BaseDatePicker from '@/components/parts/atoms/BaseDatePicker'
import TagList from '@/components/parts/molecules/TagList'
import moment from 'moment'
import { mapGetters } from 'vuex'
import DetectWindowSize from '@/components/mixins/DetectWindowSize'
import { ValidationProvider } from 'vee-validate'
import '@/utils/validation_rules'
import { waitThenMouseOver } from '@/utils/vDatePicker'

export default {
  name: 'SearchAreaDetailForm',

  components: {
    BaseCheckBox,
    BaseSelectBox,
    BaseTextBox,
    BaseButtonTrash,
    BaseRadioButton,
    BaseDatePicker,
    TagList,
    ValidationProvider
  },

  mixins: [DetectWindowSize],

  props: {
    index: { type: Number },
    searchCondition: { type: Object },
    selectBoxData: { type: Array },
    isOwnersPage: { type: Boolean, default: false }
  },

  data() {
    return {
      updatedDateCount: 0,
      timeoutIds: []
    }
  },

  computed: {
    ...mapGetters({
      species: 'species/getData',
      staffs: 'staffs/selectDataZero',
      ownerTags: 'ownerTags/getData',
      selectDataPatientSexes: 'master/selectPatientSexesZero'
    }),
    selectId() {
      return this.searchCondition.selectId
    },
    inputType() {
      const selectBoxDatum = this.selectBoxData.find(
        v => v.id === this.searchCondition.selectId
      )
      return selectBoxDatum !== undefined ? selectBoxDatum.type : ''
    },
    textBoxesText() {
      return this.searchCondition.selectId === 17 ||
        this.searchCondition.selectId === 7
        ? '歳'
        : '円'
    },
    radioButtonData() {
      return this.searchCondition.radioButtonData
        ? this.searchCondition.radioButtonData
        : this.searchCondition.selectId === 8
        ? //飼主IDの有無
          [
            { id: 1, eachValue: '有り', labelName: '有り' },
            { id: 2, eachValue: '無し', labelName: '無し' }
          ]
        : this.searchCondition.selectId === 9
        ? //飼主の性別
          [
            { id: 3, eachValue: '未設定', labelName: '未設定' },
            { id: 4, eachValue: '男性', labelName: '男性' },
            { id: 5, eachValue: '女性', labelName: '女性' },
            { id: 6, eachValue: 'その他', labelName: 'その他' }
          ]
        : this.searchCondition.selectId === 10
        ? //メールアドレスの有無
          [
            { id: 7, eachValue: '有り', labelName: '有り' },
            { id: 8, eachValue: '無し', labelName: '無し' }
          ]
        : this.searchCondition.selectId === 19
        ? //次回予約の有無
          [
            { id: 9, eachValue: '有り', labelName: '有り' },
            { id: 10, eachValue: '無し', labelName: '無し' }
          ]
        : //死亡患者を含む
          [
            { id: 11, eachValue: '全て', labelName: '全て' },
            { id: 12, eachValue: '死亡患者のみ', labelName: '死亡患者のみ' },
            { id: 13, eachValue: '生存患者のみ', labelName: '生存患者のみ' }
          ]
    },
    selectData() {
      return this.searchCondition.selectData
        ? this.searchCondition.selectData
        : this.searchCondition.selectId === 13
        ? //患者の性別
          this.selectDataPatientSexes
        : this.searchCondition.selectId === 14
        ? //患者の種別
          this.species
        : this.searchCondition.selectId === 18
        ? //患者の主治医
          this.staffs
        : this.searchCondition.selectId === 21
        ? //保険
          [
            { id: 0, name: 'アニコム' },
            { id: 1, name: 'アイペット' },
            { id: 2, name: 'ドコモ' },
            { id: 3, name: 'ソニー' },
            { id: 4, name: '保険なし' }
          ]
        : this.searchCondition.selectId === 25
        ? //患者の誕生月
          [...Array(12)].map((_, i) => ({ id: i + 1, name: `${i + 1}月` }))
        : //言語
          [
            { id: 0, name: '日本語' },
            { id: 1, name: '英語' }
          ]
    },
    selectBoxWidth() {
      return this.mixinWindowWidth < 1024
        ? { width: '100px' }
        : { width: '170px' }
    },
    radioButtonWidth() {
      return this.mixinWindowWidth < 1024
        ? { marginLeft: '0px', marginRight: '25px' }
        : { marginLeft: '10px', marginRight: '30px' }
    },
    radioButtonPeriodShowFlg() {
      return (
        this.inputType === 'radioButtonPeriod' &&
        this.searchCondition.text === this.radioButtonData[1].eachValue
      )
    },
    date() {
      const makeStartEnd = searchConditionText => {
        const [start, end] =
          searchConditionText.length > 0
            ? searchConditionText
                .split(',')
                .map(v => moment(v, 'YYYYMMDD').toDate())
            : [new Date(), new Date()]
        return { start, end }
      }
      if (this.inputType === 'datePicker') {
        return makeStartEnd(this.searchCondition.text)
      } else if (this.inputType === 'radioButtonPeriod') {
        return makeStartEnd(this.searchCondition.text2)
      } else if (this.inputType === 'oneDatePickerSelectBox') {
        return this.searchCondition.text2.length > 0
          ? moment(this.searchCondition.text2, 'YYYYMMDD').toDate()
          : new Date()
      } else {
        //上記のinputType以外の場合はthis.dateは使用しないためnullで返す
        return null
      }
    },
    isDeletedCondition() {
      if (!this.isOwnersPage) return false
      const { selectId, text } = this.searchCondition || {}
      //検索条件がタグの場合
      if (selectId === 7) {
        if (!Array.isArray(text) || text.length === 0) return false
        const existingTagIds = new Set(this.ownerTags.map(v => v.id))
        // 検索条件のタグの中に、現在存在するタグ一覧に含まれないタグがある場合はtrueを返す
        return text.some(tagId => !existingTagIds.has(tagId))
      }
      // 検索条件が種別の場合
      if (selectId === 14) {
        if (text === '' || text === null || text === undefined) return false
        return !this.species.some(v => v.id === text)
      }
      // 検索条件が主治医の場合
      if (selectId === 18) {
        if (text === '' || text === null || text === undefined) return false
        return !this.staffs.some(v => v.id === text)
      }
      return false
    }
  },

  mounted() {
    document.addEventListener('toggle-popover', this.onTogglePopover)
  },

  beforeDestroy() {
    document.removeEventListener('toggle-popover', this.onTogglePopover)
    this.timeoutIds.forEach(timeoutId => clearTimeout(timeoutId))
  },

  watch: {
    selectId() {
      if (this.inputType === 'datePicker') {
        this.inputDate({ start: new Date(), end: new Date() })
      } else if (this.inputType === 'oneDatePickerSelectBox') {
        this.inputOneDate2(new Date())
      } else if (this.inputType === 'radioButtonPeriod') {
        this.inputDate2({ start: new Date(), end: new Date() })
      }
    }
  },

  methods: {
    select(id) {
      const idIndex = { id, index: this.index }
      this.$emit('select', idIndex)
    },
    inputText(text) {
      const textObj = { text, index: this.index, type: this.inputType }
      this.$emit('input-text', textObj)
    },
    inputText2(text) {
      const textObj = { text, index: this.index, type: this.inputType }
      this.$emit('input-text2', textObj)
    },
    inputText3(text) {
      const textObj = { text, index: this.index, type: this.inputType }
      this.$emit('input-text3', textObj)
    },
    //↓現状inputOneDateという名前の関数はないですが、この関数はtest2の方の値を変更するため、
    // 関数名に2をつけて他の関数と統一感があるようにしました。
    inputOneDate2(date) {
      const dateText = moment(date).format('YYYYMMDD')
      const textObj = {
        text: dateText,
        index: this.index,
        type: this.inputType
      }
      this.$emit('input-text2', textObj)
    },
    inputDate(obj) {
      const dateText = `${moment(obj.start).format('YYYYMMDD')},${moment(
        obj.end
      ).format('YYYYMMDD')}`
      const textObj = {
        text: dateText,
        index: this.index,
        type: this.inputType
      }
      this.$emit('input-text', textObj)
      this.updatedDateCount++
    },
    inputDate2(obj) {
      const dateText = `${moment(obj.start).format('YYYYMMDD')},${moment(
        obj.end
      ).format('YYYYMMDD')}`
      const textObj = {
        text: dateText,
        index: this.index,
        type: this.inputType
      }
      this.$emit('input-text2', textObj)
      this.updatedDateCount++
    },
    clear(key) {
      const clearObj = { index: this.index, key }
      this.$emit('clear', clearObj)
    },
    trash() {
      this.$emit('trash', this.searchCondition.id)
    },
    selectTag(tagId) {
      if (this.isDeletedCondition) this.removeDeletedTags()
      this.$emit('select-tag', tagId, this.index)
    },
    toggleTagOption(boolean) {
      this.$emit('toggle-tag-option', this.index, boolean)
    },
    removeDeletedTags() {
      // 検索条件のタグの中に、現在存在するタグ一覧に含まれないタグがある場合は、削除済みタグを除いたタグのidの配列を上書きする
      const existingTagIds = new Set(this.ownerTags.map(v => v.id))
      const filtered = this.searchCondition.text.filter(tagId =>
        existingTagIds.has(tagId)
      )
      if (filtered.length !== this.searchCondition.text.length) {
        this.$emit('input-text', {
          text: filtered,
          index: this.index,
          type: this.inputType
        })
      }
    },
    async onTogglePopover() {
      const timeoutIdDate = await waitThenMouseOver(
        this.$refs.vDatePickerDate,
        this.onClickDate
      )
      const timeoutIdOneDate2 = await waitThenMouseOver(
        this.$refs.vDatePickerOneDate2,
        this.onClickOneDate2
      )
      const timeoutIdDate2 = await waitThenMouseOver(
        this.$refs.vDatePickerDate2,
        this.onClickDate2
      )
      this.timeoutIds.push(timeoutIdDate)
      this.timeoutIds.push(timeoutIdOneDate2)
      this.timeoutIds.push(timeoutIdDate2)
    },
    async onClickDate() {
      const timeoutIdDate = await waitThenMouseOver(this.$refs.vDatePickerDate)
      this.timeoutIds.push(timeoutIdDate)
    },
    async onClickOneDate2() {
      const timeoutIdOneDate2 = await waitThenMouseOver(
        this.$refs.vDatePickerOneDate2
      )
      this.timeoutIds.push(timeoutIdOneDate2)
    },
    async onClickDate2() {
      const timeoutIdDate2 = await waitThenMouseOver(
        this.$refs.vDatePickerDate2
      )
      this.timeoutIds.push(timeoutIdDate2)
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin v-date-picker($width: 265px) {
  ::v-deep {
    > span {
      .v-date-picker {
        box-sizing: border-box;
        text-align: right;
        padding-right: 12px;
        width: $width;
        height: 33px;
        border-radius: 5px;
        border: solid 2px #{$light-grey};
        text-indent: 5px;
        cursor: pointer;
        background-image: url('../../../assets/images/calendar.png');
        background-size: 18px 18px;
        background-repeat: no-repeat;
        background-position: 5px center;
      }
    }
  }
}
.search-area-detail-form {
  > .form-main-row {
    display: flex;
    > .select-box {
      margin-right: 20px;
    }
    > .date-picker {
      margin-right: 20px;
    }
    @include v-date-picker();
    @include validate-message();
    > .validate {
      margin-bottom: 5px;
      > .input-form {
        margin-right: 20px;
      }
    }
    > .radio-button-form {
      display: flex;
    }
    > .one-date-picker-select-box {
      display: flex;
      gap: 0 10px;
      @include v-date-picker(auto);
    }
    > .text-boxes {
      display: flex;
      margin-bottom: 5px;
      @include validate-message();
      > .young {
        margin-left: 10px;
        line-height: 33px;
      }
      > .kara {
        margin: 0 10px;
        line-height: 33px;
      }
      > .old {
        margin: 0 20px 0 10px;
        line-height: 33px;
      }
    }
    > .radio-button-period-form {
      display: flex;
      > .radio-buttons {
        margin-top: 2px;
        display: flex;
      }
      @include v-date-picker();
    }
    > .period-radio-button-form {
      display: flex;
      align-items: center;
      margin-right: 20px;
      > .period {
        display: flex;
        align-items: center;
        @include validate-message();
        > .wavy-line {
          margin: 0 10px;
        }
      }
      > .radio-buttons {
        margin-left: 15px;
        display: flex;
        > .label {
          margin-right: 10px;
        }
        ::v-deep .base-radio-button label {
          padding-left: 15px;
        }
      }
    }
    > .tag-select-form {
      margin-top: 2px;
      > .tag-list-wrapper {
        max-width: 1000px;
      }
      > .checkbox-wrapper {
        margin-top: 10px;
        display: inline-block;
      }
    }
  }
  > .deleted-error {
    margin-top: 8px;
    color: #{$tomato};
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
